import S from './SingleDam.module.css'
import F from './AllFarmsAdmin.module.css'
import G from './ListDam.module.css'
import D from '../images/cow.svg'
import Note from '../images/note.svg'

import DeleteIcon from '@mui/icons-material/Delete';
import RateReviewIcon from '@mui/icons-material/RateReview';
import InfoIcon from '@mui/icons-material/Info';
import ReportIcon from '@mui/icons-material/Report';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import {  CycloneOutlined, DateRange, DateRangeRounded, Delete, DeleteForever, Edit, EventAvailable, Female, HomeWork, HorizontalSplitSharp, Label, RateReview, Sell, SensorDoor, Sensors, SplitscreenOutlined, TitleOutlined, TitleRounded } from '@mui/icons-material'
import NoSegmentLabels from '../Components/MyGauge'
import StChart from '../Components/StockChart'
import { useGlobalContext } from '../Components/Context'
import EditModalDam from '../Components/EditModalDam';
import { useEffect, useRef, useState } from 'react'
import HistoryIcon from '@mui/icons-material/History';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import {  Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loginSuccessC } from '../redux/slices/singleCattleSlice'
import DeleteCattle from '../Components/DeleteCattle'
import StChart2 from '../Components/StockChart2';
import AddComment from '../Components/AddCattleComment';
import { addComments } from '../redux/slices/commentsSlice';
import EditComment from '../Components/editCattleComment';
import apiService from '../api/ApiService';
import DeleteComm from '../Components/deleteComment';
import ChangePen from '../Components/changePenMOdal';
import CommentList from '../Components/cardThemes/CommentList';
import ChangeStatus from '../Components/ChangeCattleStatusModal';
import ChangeStatusCycle from '../Components/ChangeCattleCycleModal';
import { Pagination } from '@mui/material';
import { paginateCount } from '../api/helper';
import { Col, Container } from 'react-bootstrap';
import EmptyReturn from '../Components/EmptyReturn'
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker'
const moment=require('moment-jalaali');


const CommentsListComp=({flag,penId,farmId})=>{
  const [iindex,setIindex]=useState()
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null
  });
    const [selected,setSelected]=useState('')
    const {currentComments}=useSelector(state=>state.comments)
    const {cattleId}=useSelector(state=>state.list)
    const {currentTheme}=useSelector(state=>state.p.admin)
    const [total,setTotal]=useState(1)
    const [page,setPage]=useState(0)
    const [types,setTypes]=useState([])
    const [commentType,setCommentType]=useState(null)
    const {currentPens}=useSelector(state=>state.pens)

    const [comId,setComId]=useState('')
    const {openModallComment,isModalCommentOpen,isModalEditCommentOpen,openEditModallComment,openD,closeD,opens,openModallTime,isModalTimeOpen}=useGlobalContext()
   
    
    const {id}=useParams();
    const dispatch=useDispatch()

    const getComments=async()=>{
      let geregorian1=moment(`${selectedDayRange.from?.year}-${selectedDayRange.from?.month}-${selectedDayRange.from?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
  
      
      let geregorian2=moment(`${selectedDayRange.to?.year}-${selectedDayRange.to?.month}-${selectedDayRange.to?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
        const data=JSON.stringify({
            "skip": page?(page-1)*paginateCount:0,
            "take": paginateCount,
            "fromDate": selectedDayRange.from?geregorian1:null,
            "toDate": selectedDayRange.to?geregorian2:null,
            "cattleId": id?id:cattleId,
            "cattleCommentTypeId": commentType?+commentType:null
          })
        const res=await apiService.getCattleCommetns(data)
        dispatch(addComments(res.data.data))
        setTotal(Math.ceil(res.data.totalCount/paginateCount))

        
    }
    const getCommentsPen=async()=>{
        let geregorian1=moment(`${selectedDayRange.from?.year}-${selectedDayRange.from?.month}-${selectedDayRange.from?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
    
    
        let geregorian2=moment(`${selectedDayRange.to?.year}-${selectedDayRange.to?.month}-${selectedDayRange.to?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
          const data=JSON.stringify({
              "skip": page?(page-1)*paginateCount:0,
              "take": paginateCount,
              "fromDate": selectedDayRange.from?geregorian1:null,
              "toDate": selectedDayRange.to?geregorian2:null,
              "penId": penId?penId:null,
             "penCommentTypeId": commentType?+commentType:null
            })
          const res=await apiService.getPensCommentList(data)
          dispatch(addComments(res.data.data))
          setTotal(Math.ceil(res.data.totalCount/paginateCount))
  
          
      }
      const getCommentsFarm=async()=>{
        let geregorian1=moment(`${selectedDayRange.from?.year}-${selectedDayRange.from?.month}-${selectedDayRange.from?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
    
    
        let geregorian2=moment(`${selectedDayRange.to?.year}-${selectedDayRange.to?.month}-${selectedDayRange.to?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
          const data=JSON.stringify({
              "skip": page?(page-1)*paginateCount:0,
              "take": paginateCount,
              "fromDate": selectedDayRange.from?geregorian1:null,
              "toDate": selectedDayRange.to?geregorian2:null,
              "farmId": farmId,
              "farmCommentTypeId": commentType?+commentType:null
            })
          const res=await apiService.getCommentsFarm(data)
          dispatch(addComments(res.data.data))
          setTotal(Math.ceil(res.data.totalCount/paginateCount))
  
          
      }
    const handlePage = (event, value) => {
      setPage(value);
    };
    const getTypes=async()=>{
        
      const res=await apiService.getCattleComment()
      setTypes(res.data)
  
}
const getPensTypes=async()=>{
        
    const res=await apiService.getPensCommentsTypes()
    setTypes(res.data)

}
const getFarmsTypes=async()=>{
        
  const res=await apiService.getCommentFarmTypes()
  setTypes(res.data)

}       
    const renderCustomInput = ({ ref }) => (
      <>
        
        <input
      name="birth"
      autoComplete="off"
      ref={ref} // necessary
      placeholder='تاریخ تولد'
      value={selectedDayRange.from?`از ${selectedDayRange.from?.year}/${selectedDayRange.from?.month}/${selectedDayRange.from?.day}  تا  ${selectedDayRange.to?.year?selectedDayRange.to?.year:'-'}/${selectedDayRange.to?.month?selectedDayRange.to?.month:'-'}/${selectedDayRange.to?.day?selectedDayRange.to?.day:'-'}`:''}
      className="opop2" // a styling class
    />
    <label for="" class="labelSS9"><DateRangeRounded/> فیلتر بر اساس بازه زمانی </label>
    
      </>
    )
    useEffect(()=>{
        flag=='pens'&&getPensTypes()
        flag=='cattle'&&getTypes()
        flag=='cattles'&&getTypes()
        flag=='farm'&&getFarmsTypes()
    },[id])
    useEffect(()=>{
      if(selectedDayRange.to!==null){
        if(page===0){
          flag=='pens'?getCommentsPen(): getComments()
        }
        setPage(0)
      }
    },[selectedDayRange.to])
    useEffect(()=>{
          
        flag=='pens'&&getCommentsPen()
       flag=='cattle'&&getComments()
       flag=='cattles'&&getComments()
        flag=='farm'&&getCommentsFarm()
          
    },[page,commentType,id,penId,cattleId])
    return <>
    
            
            
    
    {flag=='pens'&&penId&&<span title='افزودن یادداشت' onClick={openModallComment} className={G.EditBtnTableDam}>
                <RateReview sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </span>}
            {flag=='farm'&&<span title='افزودن یادداشت' onClick={openModallComment} className={G.EditBtnTableDam}>
                <RateReview sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </span>}
    <div style={{width:'100%',direction:'rtl'}} className='d-flex justify-content-between'>
    <select style={{direction:'rtl',alignSelf:'end'}}   id='sele'  name='sele' className={`selectInp ${G.selectStyle}`} value={commentType} onChange={(e)=>setCommentType(e.target.value)} >
    <option  value={'null'} >همه</option>
                {types?.length&&types.map((item,index)=>{
                                         return <option key={index}  value={item?.id}>{item?.title} {item?.count}</option>
                
                            })}
                            
                       
                    </select>
                    <div class="inputContainerSS">
                           <DatePicker
                           value={selectedDayRange}
                           onChange={setSelectedDayRange}
                             locale='fa'
                             calendarClassName="birthCalender"
                             renderInput={renderCustomInput}
                             />
                             
                           
                              
                       </div>
    </div>
    {!currentTheme&&currentComments?.length&&<div className={F.AnimContentLI} style={{borderTopLeftRadius:0}} data-aos='fade'>
    
          <table >
              <thead>
              <tr>
          <th>
          <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>          </th>
          <th>
          <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
          </th>
          {flag=='cattles'&&<th><div className='LogoFormT'><div><span>
                <Label/>
                </span>
                    </div></div>
          </th>}
          {flag=='pens'&&<th><div className='LogoFormT'><div><span>
                <Label/>
                </span>
                    </div></div>
          </th>}
          <th>
          <div className='LogoFormT'><div><span>
                <TitleOutlined/>
                </span>
                    </div></div>
          </th>
          
          <th>
          <div className='LogoFormT'><div><span>
                <HorizontalSplitSharp/>
                </span>
                    </div></div>
          </th>
          <th>
          <div className='LogoFormT'><div><span>
                <DeleteForever/>
                </span>
                    </div></div>
          </th>
          <th>
          <div className='LogoFormT'><div><span>
                <InfoIcon/>
                </span>
                    </div></div>
          </th>
          
        </tr>
                <tr>
                  <th>
                    ردیف
                  </th>
                  <th>
                     زمان
                  </th>
                  {flag=='cattles'&&<th>
                    دام
                    </th>}
                    {flag=='pens'&&<th>
                    بهاربند
                    </th>}
                  <th>
                     موضوع
                  </th>
                  
                  <th>
                     دسته
                  </th>
                  <th>
                     حذف
                  </th>
                  <th>
                     جزئیات
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                {
                  currentComments?.map((item,index)=>{
                    const {entryDate}=item;
                    const pbirth=moment(entryDate).format('jYYYY-jMM-jDD HH:mm')
                    return <tr key={index}>
                    <td>
                    {(index+1)+(page==0?0:page-1)*8}
                    </td>
                    <td>
                      {pbirth}
                    </td>
                    {flag=='cattles'&&<td style={{width:'110px'}}>
                    <div className={`itemCattleFilter`} style={{border:'none',backgroundColor:'transparent'}} key={index}>
        <div className='d-flex' style={{gap:'7px'}}>
          <div className='d-flex align-items-center' style={{gap:'7px'}}>  <Sell color='success' fontSize='small'/>  {item?.necklaceNumber?item?.necklaceNumber:'〰'}</div>
          <div className='d-flex align-items-center' style={{gap:'7px'}}><Sell color='success' fontSize='small'/> {item?.bodyNumber?item?.bodyNumber:'---'}</div>
          <div className='d-flex align-items-center' style={{gap:'7px'}}><Sell color='success' fontSize='small'/>  {item?.earTagNumber?item?.earTagNumber:'---'}</div>
        </div>
        
      </div>
                      </td>}
                {flag=='pens'&&<td>
                      {currentPens.find(type=>{
                        
                        return type.id==item.penId
                      })?.name}
                    </td>}
                    <td>
                      {item.title?.substring(0,16)}
                    </td>
                    
                    <td>
                    {item?.cattleCommentTypeTitle||item?.penCommentTypeTitle||item?.farmCommentTypeTitle}
                    </td>
                    <td 
                    onClick={()=>{openD();setComId(item.id)}}>
                      <div className='deldel' ><Delete/> </div>
                    </td>
                    <td className={F.DetIc}>
                      <div onClick={()=>{setIindex(index);openEditModallComment();setSelected(item)}}>
                      <div className='btnCardDAm'> مشاهده</div>

                      </div>
                    </td>
                    
                    
                  </tr>
                  
                  })
                }

              </tbody>
            </table>
          </div>}
          
          {!currentTheme&&!currentComments?.length&&<EmptyReturn/>}
          {currentTheme&&<CommentList types={types} flag={flag}/>}
          <div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
    {isModalCommentOpen&&<AddComment flag={flag} />}
    {!currentTheme&&isModalEditCommentOpen&&<EditComment iindex={iindex} types={types} selected={selected} flag={flag} />}
    
    {!currentTheme&&opens&&<DeleteComm penr={comId} type={flag}/>}

    </>
}

export default CommentsListComp